import type { CalendarEvent } from '../services/api';

/** atp_priority value for an A-race (TrainingPeaks). */
export const ATP_PRIORITY_A = 1;

export type FatigueLevel = 'fresh' | 'normal' | 'high';

export const FATIGUE_LABELS: Record<FatigueLevel, string> = {
  fresh: 'Fresh',
  normal: 'Normal',
  high: 'High',
};

/** Map TSB (form) to coach-facing fatigue label. */
export function fatigueLevelFromTsb(tsb: number | null | undefined): FatigueLevel | null {
  if (tsb == null || Number.isNaN(tsb)) return null;
  if (tsb > 5) return 'fresh';
  if (tsb >= -15) return 'normal';
  return 'high';
}

function eventDateISO(ev: Pick<CalendarEvent, 'event_date'>): string {
  if (!ev.event_date) return '';
  return String(ev.event_date).split(/[T ]/)[0];
}

/** Next upcoming A-priority race on or after `fromISO` (default today). */
export function getNextGoalRace(
  events: CalendarEvent[],
  fromISO = new Date().toISOString().slice(0, 10),
): CalendarEvent | null {
  const upcoming = events
    .filter(ev => ev.atp_priority === ATP_PRIORITY_A)
    .map(ev => ({ ev, iso: eventDateISO(ev) }))
    .filter(({ iso }) => iso && iso >= fromISO)
    .sort((a, b) => a.iso.localeCompare(b.iso));

  return upcoming[0]?.ev ?? null;
}

/** Flatten calendar day rows into unique events. */
export function collectCalendarEvents(
  days: Array<{ events?: CalendarEvent[] }>,
): CalendarEvent[] {
  const byId = new Map<number, CalendarEvent>();
  for (const day of days) {
    for (const ev of day.events ?? []) {
      if (ev?.id != null) byId.set(ev.id, ev);
    }
  }
  return [...byId.values()];
}

export function formatGoalRaceLabel(event: CalendarEvent | null): string | null {
  if (!event) return null;
  const name = event.name?.trim();
  if (name) return name;
  const duration = event.race_type_duration?.trim();
  return duration || null;
}
